import React, { useState } from "react"
import PropTypes from "prop-types"
import * as styles from "./MainNavAccordion-tw-styles"
import MainNavAccordionItem from "./MainNavAccordionItem"

const MainNavAccordion = props => {
  const [clicked, setClicked] = useState("0")
  const { collection } = props
  const style = styles["defaultStyle"]
  const handleToggle = index => {
    if (clicked === index) {
      return setClicked("0")
    }
    setClicked(index)
  }

  return (
    <div className={style?.mobileNavParentIN}>
      <ul
        style={{ display: "flex", flexDirection: "column" }}
        className={style?.mobileNavParentINUL}
      >
        {collection.map((item, index) => (
          <MainNavAccordionItem
            onToggle={() => handleToggle(index)}
            active={clicked === index}
            key={index}
            item={item}
          />
        ))}
      </ul>
    </div>
  )
}

MainNavAccordion.propTypes = {
  collection: PropTypes.array,
}

export default MainNavAccordion
